import axios from "../axios";

const requestOtp = async function (accessToken, uuid) {
    try {
        const response = await axios.post('/bank-account/requestOtp', {
            uuid
        }, {
            headers: {
                'Authorization': accessToken
            },
            params: {
                uuid
            }
        });
        return response.data;
    }
    catch (e) {
        return {
            success: false,
            errorCode: e.response?.status,
            message: e.response?.data?.message,
            data: e.response?.data?.data
        }
    }
}

export default requestOtp;
